import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
import formatDate from 'ember-intl/helpers/format-date';
import t from 'ember-intl/helpers/t';
import { not } from 'ember-truth-helpers';
import eq from 'ember-truth-helpers/helpers/eq';
import PhoneLink from 'parog-web/components/phone-link';
import ProductName from 'parog-web/components/product-name';
import type Patient from 'parog-web/models/patient';
import TitledLabel from 'ui-kit/components/titled-label';
export interface Signature {
    Args: {
        patient: Patient;
        propertyName: string;
        description: string;
        format?: 'titleize' | 'email' | 'phone' | 'code' | 'gender' | 'birthday';
        displayEmpty?: boolean;
    };
    Blocks: {
        copyButton?: [];
    };
}
export default class LabeledPatientInformation extends Component<Signature> {
    titleize(string1: string): string {
        return string1.toLowerCase().replace(/(?:^|\s|-|\/)\S/g, function(m1) {
            return m1.toUpperCase();
        });
    }
    getNestedProperty(obj1: Patient, path1: string) {
        return path1.split('.').reduce((acc1, key1)=>acc1 && acc1[key1], obj1);
    }
    get propertyValue(): string {
        const value1 = this.args.patient?.[this.args.propertyName];
        if (this.args.propertyName.includes('.')) {
            return this.getNestedProperty(this.args.patient, this.args.propertyName);
        }
        if (this.args.format === 'titleize' && value1) {
            return this.titleize(value1);
        }
        return value1;
    }
    get hasValue(): boolean {
        return Boolean(this.propertyValue);
    }
    get shouldDisplay(): boolean | undefined {
        return this.hasValue || this.args.displayEmpty;
    }
    static{
        template(`
    {{#if this.shouldDisplay}}
      <div class='column'>
        <TitledLabel data-test-label={{@propertyName}}>
          <:title>
            {{#if (eq @format 'code')}}
              {{@description}}
              <ProductName />
            {{else}}
              {{@description}}
            {{/if}}
            {{yield to='copyButton'}}
          </:title>
          <:body>
            {{#if (not this.hasValue)}}
              -
            {{else if (eq @format 'email')}}
              <a href='mailto:{{this.propertyValue}}'>{{this.propertyValue}}</a>
            {{else if (eq @format 'gender')}}
              {{t 'patient.gender' gender=this.propertyValue}}
            {{else if (eq @format 'birthday')}}
              {{formatDate this.propertyValue format='DD/MM/YYYY'}}
            {{else if (eq @format 'phone')}}
              <PhoneLink @phone={{this.propertyValue}} />
            {{else}}
              {{this.propertyValue}}
            {{/if}}
          </:body>
        </TitledLabel>
      </div>
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
